module.exports = __webpack_public_path__ + "static/img/room_titletwo2.a6094ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room_titletwo2.png
// module id = jkZC
// module chunks = 0